<template>
	<div id='ae' class='' v-loading='loading'>

		<el-button type='primary' @click='edit'>{{$t('app_edit')}}</el-button>

		<div class='gPageBorder gTopMg' v-show="true" style=''>

			<p class='gCtColor gPTitle' style=''>{{$t('app_baseInfo')}} </p>

			<el-row class='gPdTB'>


				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_deviceName')">
							{{detail.terminalName?detail.terminalName : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_deviceNo')">
							{{detail.terminalNo?detail.terminalNo : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_type') ">
							{{detail.typeName?detail.typeName : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_model')">
							{{detail.modelName?detail.modelName : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_firm')">
							{{detail.manufName?detail.manufName : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_distributor')">
							{{detail.mechName?detail.mechName : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_addres')" style="width:calc(100% - 10px);">
							{{detail.address?detail.address : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('lin_global.remark')">
							{{detail.memo?detail.memo : '-'}}
						</el-form-item>
					</el-form>
				</el-col>


			</el-row>

		</div>



		<div class='gPageBorder gTopMg' v-show="true" style=''>

			<p class='gCtColor gPTitle' style=''>{{$t('app_softinfo')}} </p>

			<el-row class='gPdTB'>

				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('lin_global.ter_status') ">
							{{detail.terminalStatus?sstatus[detail.terminalStatus] : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('terminal.list.ztgxsj')">
							{{detail.updateTime?detail.updateTime : '-'}}
						</el-form-item>
					</el-form>
				</el-col>


				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_appVer') ">
							{{detail.apkVersion?detail.apkVersion : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_srcver')">
							{{detail.resourceVersion?detail.resourceVersion : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('terminal.details.system_version')">
							{{detail.sysVersion?detail.sysVersion : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('terminal.details.system_spversion')">
							{{detail.spVersion?detail.spVersion : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('app_rots_5')">
							{{detail.mtVersion?detail.mtVersion : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('terminal.details.hard_info')">
							{{detail.hardware?detail.hardware : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('terminal.details.Electric_quantity')">
							{{detail.bat?detail.bat : '-'}}
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item label="IMEI">
							{{detail.imei?detail.imei : '-'}}
						</el-form-item>
					</el-form>
				</el-col>
				
				<el-col :span='12'>
					<el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('terminal.details.network')">
							{{detail.rssi?detail.rssi : '-'}}
						</el-form-item>
					</el-form>
				</el-col>
				
				<el-col :span='12'>
					<el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
						<el-form-item :label="$t('lin_global.dest_status')">
							{{detail.activeStatus?detail.activeStatus : '-'}}
						</el-form-item>
					</el-form>
				</el-col>


				<!--        <el-col :span='24'>
          <el-form class='gShowLeftForm'  label-position='left' label-width="15%">
              <el-form-item :label="$t('terminal.details.hard_info')" style="width:calc(100% - 10px);">
                {{detail.hardware?detail.hardware : '-'}}
              </el-form-item>
          </el-form>
        </el-col> -->

			</el-row>

		</div>





	</div>
</template>

<style>
	.ldt-word-main {
		color: rgb(72, 87, 106)
	}

	.ldt-word-title {
		color: #99A9BF;
	}

	pre {
		white-space: pre-wrap;
		word-wrap: break-word;
		white-space: -moz-pre-wrap;
		white-space: -pre-wrap;
		white-space: -o-pre-wrap;
		word-break: break-all;
	}

	.ldt-launch {
		width: calc(100% - 48px);
		height: 100%;
		background: none;
	}

	.ldt-launch td {
		width: 30%;
		background: none;
	}

	/* upload */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.capture {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		display: inline-block;
	}

	.capture div {
		float: left;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	/* upload */
	.sm-avatar-uploader-icon {
		font-size: 36px;
		color: #8c939d;
		width: 72px;
		height: 72px;
		line-height: 72px;
		text-align: center;
	}

	.sm-avatar {
		width: 64px;
		height: 64px;
		display: block;
	}
</style>

<script>
	export default {
		data() {
			var that = this
			return {
				sstatus: {
					'0': this.$t('app_new'),
					'1': this.$t('app_enable')
				},
				labelttw: "30%",
				dLoading: false,
				srchValue: '',
				reason: '',
				config: '',
				captures: [],
				loading: 0,
				dialogVisible: false,
				notPassDialog: false,
				index: 1,
				detail: '',
				tableData: [],
				total: 0,
				status: '',
				tags: [],
				mech: localStorage.mechanismId,
				stModel: [{
						label: this.$t('app_online'),
						vl: '1'
					},
					{
						label: this.$t('app_offline'),
						vl: '2'
					},
					{
						label: this.$t('app_sleep'),
						vl: '3'
					},
					// {label: '锁定', vl: '2'}
				],
				mechanismData: {
					callback(value) {
						that.mech = value
						that.selectChange(value)
					}
				}
			}
		},
		components: {},
		computed: {
			/*avtStyle () {
			  var url = this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : require('../../../assets/df.png')
			  
			  return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')'
			},*/
			showUploadNew() {
				console.log('ccc', this.config.data)
				if (this.config.data) {
					if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			}
		},
		methods: {
			edit() {
				this.$router.push({
					path: '/non-it-eq/device/detail/edit',
					query: {
						data: this.detail
					}
				})
			},
			bindOperate(row) {
				this.dLoading = 1
				this.$fstTest(this.config.recordId, row.terminalNo, (res) => {
					this.dLoading = 0
					if (res.status === 200) {
						this.$message.success(this.$t('app_tipViewTask'))
						this.notPassDialog = false
					} else {
						this.$message.error(res.message)
					}
				}, (error) => {
					this.dLoading = 0
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			verify(vl) {
				if (vl === '2') {
					// yes
					this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
						confirmButtonText: this.$t('app_sure'),
						cancelButtonText: this.$t('app_cancel'),
						type: 'warning'
					}).then(() => {
						this.verifyRqs(vl)
					}).catch(() => {})
				} else if (vl === '3') {
					// no
					this.notPassDialog = true
				}
			},
			verifyRqs(vl) {
				this.loading = 1
				this.$verifyFst(this.config.id, this.reason, vl, (res) => {
					this.loading = 0
					if (res.status === 200) {
						this.$message.success(res.message)
						this.$router.go(-1)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.$message.error(this.$t('app_rqsError'))
					this.loading = 0
				})
			},
			srchDevice() {
				this.getDevices()
			},
			selectChange(vl) {
				this.getDevices()
			},
			pageSelect(index) {
				this.index = index
				this.getDevices()
			},
			pageSized(val) {
				this.$gRow = val
				this.getDevices()
			},
			getDevices() {
				var vl = this.srchValue ? this.srchValue : ''
				// var channel = this.channelId ? this.channelId : ''
				var status = this.status ? this.status : ''
				var mc = this.mech
				this.loading = 1
				this.$getDvDevices(this.index, this.$gRow, mc, vl, status, '', '', '', '', '', (res) => {
					console.log('dv', res)
					this.loading = 0
					if (res.data) {
						this.tableData = res.data
						this.total = res.total
					}
				}, () => {
					// error
					this.loading = 0
				})

			},
			setInstallType(type) {
				return this.$installType[type]
			},
			dateFormat(row, column) {
				// var date = row[column.property]
				// if (date === undefined) {
				//   return ''
				// }
				// return mm(date).format('YYYY-MM-DD hh:mm:ss')
			},
			selectChange(vl) {
				this.getDevices()
			},
			pageSelect(index) {
				this.index = index
				this.getDevices()
			},
			pageSized(val) {
				this.$gRow = val
				this.getDevices()
			},



			deleteAppHis(row) {
				// console.log(row)
				if (row.applicationid) {
					this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
						confirmButtonText: this.$t('app_sure'),
						cancelButtonText: this.$t('app_cancel'),
						type: 'warning'
					}).then(() => {
						this.loading = 1
						if (this.$appUrlTag === 0) {
							this.$deleteApp(row.applicationid, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.getAppHistory()
								} else {
									this.$message.error(res.message)
								}
							}, () => {
								// error
								this.loading = 0
							})
						} else {
							this.$deleteAppHis(row.applicationid, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.getAppHistory()
								} else {
									this.$message.error(res.message)
								}
							}, () => {
								// error
								this.loading = 0
							})
						}
					}).catch(() => {})
				}
			},

			imgFullUrl(path) {
				if (path) {
					// return this.$host + path
					// console.log('imgpath', path, this.$urls.prefix + path)
					return this.$urls.prefix + path
				} else {
					return ''
				}
			},

			getAppHistory() {
				if (!this.config.data.appName) {
					return
				}
				// console.log('pkg', this.config.data)
				this.loading = 1
				if (this.$appUrlTag === 0) {
					this.$getAppHistory(this.config.data.appName, this.config.data.packagename, (res) => {
						//console.log('his', res)
						//alert(res)
						this.loading = 0
						if (res.status === 200) {
							this.tableData = res.data
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.loading = 0
					})
				} else {

					this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, (res) => {

						console.log('his', res)
						this.loading = 0
						if (res.status === 200) {
							this.tableData = res.data
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.loading = 0
					})
				}

			},
			uploadNew() {
				// this.config = {type: 4, data: this.config}
				// this.$router.push({name: this.$t('menu.appManageSub.uploadNew')})
			},
			getdetail() {
				var did = this.$getWObj().ndObj.data
				// console.log('ddd', did)
				this.$noniteqDetail(did, (res) => {

					console.log('his', res)
					this.loading = 0
					if (res.status === 200) {
						this.detail = res.data
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.loading = 0
				})
			},
			init() {
				// this.config = this.$getWObj().stfileVerify
				// console.log(this.config)
				// this.tags = this.config.appPackage.split(',')
				// this.getDevices()
				this.getdetail()

			},

		},
		mounted() {
			this.init()
		}
	}
</script>


// WEBPACK FOOTER //
// detail.vue?06da09d8